import { createAction } from 'redux-actions'
import get from 'lodash.get'
import remove from 'lodash.remove'
import sortBy from 'lodash.sortby'

import { incidentsPagination } from '../../utils/constants'
import FileService from '../../services/FileService'
import FILE_TYPES from '../../utils/fileEnums'
import * as globalTypes from '../../actions/types'
import { fetchLoadIncidents } from '../LoadsDetails/actions'
import history from '../../history'

import * as types from './actionTypes'
import IncidentsService from './service'

export const fetchIncidentsByParams = (params) => (dispatch) => {
  if (params.page === 1 || !params.page) {
    dispatch(createAction(types.CLEAR_INCIDENTS_BY_STATUS)())
  }
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  IncidentsService.fetchIncidentsByParams({
    page: params.page || 1,
    // status,
    size: incidentsPagination,
    ...params,
    status: (params && params.status) === 'ALL' ? null : get(params, 'status', null),
  })
    .then((result) => {
      dispatch(createAction(types.FETCH_INCIDENTS_BY_STATUS)(result))
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
    })
    .catch(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
    })
}

export const fetchIncidentById = (id) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  IncidentsService.fetchIncidentById(id)
    .then((result) => {
      if (result.events && result.events.length) {
        const newEvents = [...result.events.filter((ev) => !ev.attachments)]

        result.events.forEach((event) => {
          const attachments = get(event, 'attachments', []).filter((item) => item)
          const blobs = []

          if (attachments.length) {
            attachments.forEach((path) => {
              FileService.downloadFile(path)
                .then((downloadFile) => {
                  const fileTypeIdx = path.lastIndexOf('.')
                  const fileType = path.slice(fileTypeIdx)
                  const file = {
                    preview: downloadFile,
                    type: fileType,
                    name: path.slice(path.lastIndexOf('/') + 1),
                  }
                  blobs.push(file)
                  if (blobs.length === attachments.length) {
                    remove(newEvents, (item) => item.id === event.id)
                    newEvents.push({
                      ...event,
                      blobs,
                    })
                    if (newEvents.length === result.events.length) {
                      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
                      dispatch(
                        createAction(types.FETCH_INCIDENTS_BY_ID)({
                          id,
                          data: {
                            ...result,
                            events: sortBy(newEvents, (item) => item.id),
                          },
                        }),
                      )
                    }
                  }
                })
                .catch(() => dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)))
            })
          } else {
            dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
            dispatch(
              createAction(types.FETCH_INCIDENTS_BY_ID)({
                id,
                data: {
                  ...result,
                },
              }),
            )
          }
        })
      }
    })
    .catch(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
    })
}

export const addEventToIncident = (incidentId, event) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  IncidentsService.addEventToIncident(incidentId, event)
    .then(() => {
      dispatch(fetchIncidentById(incidentId))
      dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Comentário sobre a ocorrência enviado.',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        }),
      )
    })
    .catch(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
    })
}

export const addEventToIncidentWithImages =
  (incidentId, event, attachments = []) =>
    async (dispatch) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
      try {
        const promises = attachments.map((item) =>
          FileService.upload(item, FILE_TYPES.shipping.occurrence),
        )
        const paths = await Promise.all(promises)
        dispatch(
          addEventToIncident(incidentId, {
            ...event,
            attachments: paths,
          }),
        )
      } catch (err) {
        console.log(err)
      } finally {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      }
    }

const closeIncidentWithPaths =
  (incidentId, observation, cost, resolutionId, paths) => (dispatch) => {
    IncidentsService.closeIncident(incidentId, {
      observation,
      cost,
      resolutionId,
      attachments: paths,
    })
      .then(() => {
        dispatch(fetchIncidentById(incidentId))
        dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: 'Ocorrência finalizada.',
            feedbackTitle: null,
            feedbackType: 'MESSAGE',
            styleFeedbackType: 'success',
            messageTimestamp: new Date().getTime(),
          }),
        )
      })
      .catch(() => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      })
  }

export const closeIncident =
  (incidentId, observation, cost, resolutionId, attachments = []) =>
    async (dispatch) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
      try {
        const promises = attachments.map((item) =>
          FileService.upload(item, FILE_TYPES.shipping.occurrence),
        )
        const paths = await Promise.all(promises)
        dispatch(closeIncidentWithPaths(incidentId, observation, cost, resolutionId, paths))
      } catch (err) {
        console.log(err)
      } finally {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      }
    }

export const getLoadsForIncidents = () => (dispatch) => {
  IncidentsService.getLoadsForIncidents()
    .then((result) => {
      dispatch(createAction(types.FETCH_LOADS_FOR_INCIDENT)(result))
    })
    .catch(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
    })
}

export const createIncidentWithPaths =
  (paths, destinationId, observation, occurrenceTypeId, shippingDeliveryId, target, hashId) =>
    (dispatch) => {
      const path = get(history, 'location.pathname', '')
      IncidentsService.createIncident({
        attachments: paths,
        destinationId,
        observation,
        occurrenceTypeId,
        shippingDeliveryId,
        target,
      })
        .then(() => {
          if (path.includes('/incidents')) {
            dispatch(fetchIncidentsByParams({ page: 1 }))
          }
          if (path.includes('/loads')) {
            dispatch(fetchLoadIncidents(hashId, shippingDeliveryId))
          }
          dispatch(
            createAction(globalTypes.SHOW_USER_FEEDBACK)({
              feedbackMessage: 'Ocorrência criada com sucesso.',
              feedbackTitle: null,
              feedbackType: 'MESSAGE',
              styleFeedbackType: 'success',
              messageTimestamp: new Date().getTime(),
            }),
          )
        })
        .catch(() => {
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
        })
    }

export const createIncident =
  (files = [], destinationId, observation, occurrenceTypeId, shippingDeliveryId, target, hashId) =>
    async (dispatch) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
      try {
        const promises = files.map((file) => FileService.upload(file, FILE_TYPES.shipping.occurrence))
        const filePaths = await Promise.all(promises)
        dispatch(
          createIncidentWithPaths(
            filePaths,
            destinationId,
            observation,
            occurrenceTypeId,
            shippingDeliveryId,
            target,
            hashId,
          ),
        )
      } catch (err) {
        console.log(err)
      } finally {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      }
    }

export const forwardIncident = (incidentId, target, eventId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
  IncidentsService.forwardIncident(incidentId, {
    target,
    eventId,
  })
    .then(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Encaminhado com sucesso.',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        }),
      )
    })
    .catch(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
    })
}
